const squish = (value) => `${value ?? ''}`.trim().replace(/\s+/g, ' ');

/**
 * The table of a table order (method on_site), as staff are told it.
 *
 * The backend (from !2003) sends `on_site_table_name`, the table line of the order: "7",
 * "Terrasse · 7", and for an order from before the rename the former venue plus what the guest
 * typed ("Hotel Adlon · 12"). From !2015 on it is stored as placed, so a table renamed since does
 * not change it. `on_site_table` is the live table: its name is never used to label an order.
 */
class OnSiteHelpers {
  static tableName(order) {
    // A backend from !2003 on sends the field, null included: that is the answer.
    if (order?.on_site_table_name !== undefined) {
      return order.on_site_table_name;
    }

    return OnSiteHelpers.legacyTableName(order);
  }

  /**
   * @deprecated PROD-829: for a backend rolled back below !2003, which sends only the venue
   * (`room_service_location`) and what the guest typed (`room_service_details`). Built like the
   * backend's line: "Terrasse · 7", or whichever of the two there is. A soft-deleted venue comes
   * back as Laravel's empty resource (`[]`) and counts as none.
   */
  static legacyTableName(order) {
    const venue = Array.isArray(order?.room_service_location) ? null : order?.room_service_location;
    const line = [squish(venue?.name), squish(order?.room_service_details)].filter(Boolean).join(' · ');

    return line || null;
  }

  /**
   * The order's table as staff are told it: the backend's label rule on the order's own line
   * (`OnSiteTable::labelFor`), so "7" reads "Table 7" and "Terrasse · 7" stays as it is.
   */
  static orderLabel(order, t) {
    return OnSiteHelpers.tableLabel(OnSiteHelpers.tableName(order), t);
  }

  /**
   * "Table 7" for names that start with a digit ("7", "1A"), other names as they are ("Terrace 2"),
   * null when there is none. Same rule as the backend's OnSiteTable::labelFor. `t` is the caller's
   * translator, so a receipt passes one bound to the receipt language.
   */
  static tableLabel(name, t) {
    const squished = squish(name);

    if (squished === '') {
      return null;
    }

    return /^\d/.test(squished) ? t('Shared:OnSiteTable.label', { name: squished }) : squished;
  }
}

export default OnSiteHelpers;
